import type { QueryClient } from "@tanstack/react-query";
import { supabase } from "./client";
import { authKeys } from "@/hooks/useAuth";

export function initAuthListener(queryClient: QueryClient): void {
  supabase.auth.onAuthStateChange((_event, session) => {
    queryClient.setQueryData(authKeys.session(), session);
  });
}
